import { Component, Watch } from 'vue-property-decorator';


import Superbutton from 'tivigi/src/components/Superbutton/Superbutton'
import SM2Base from '../SM2Base';
import BarDisplay from 'tivigi/src/components/BarDisplay/BarDisplay'
import FloatingWindow from 'tivigi/src/components/FloatingWindow/FloatingWindow'

import WithRender from './Metropolregionen.html';

@WithRender
@Component({
    components: { BarDisplay,  FloatingWindow,  Superbutton }
})
export default class Metropolregionen extends SM2Base {

    indicator: any = null

    min = 0
    max = 0

    latestYear = 0

   
    @Watch('indicator')
    onIndicatorChange() {

        // NOTE: Here, the only difference to "Dynamik" is the spatialUnits
        let spatialUnits = this.getSpatialUnits(['M'])

        this.latestYear = this.getLatestYear(spatialUnits[0], this.indicator.code)
    
        //#################### BEGIN Update min/max #######################
        this.min = Number.MAX_VALUE;
        this.max = Number.MIN_VALUE;


        for (let su of spatialUnits) {
            let val = this.getValue(su, this.indicator.code, this.latestYear)

            if (val < this.min) {
                this.min = val;
            }

            if (val > this.max) {
                this.max = val;
            }
        }
        //#################### END Update min/max #######################
    }
}


